<template>
    <div>
      <v-toolbar flat color="white">
             <v-tabs div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
        </v-toolbar>
        <div v-if="displayContents('dashboard')">
          <v-layout justify-center align-center>
            <v-flex xs6 sm4 md4>
            <barchart
          v-if="loaded"
          :chartdata="vlanConnectionChart"
          :options="vlanConnectionChartOptions"
        ></barchart>
          </v-flex>
          <v-flex xs6 sm4 md4>
            <linechart
          v-if="billableAccountsLoaded"
          :chartdata="billableVlanConnectionChart"
          :options="billableVlanConnectionChartOptions"
        ></linechart>
          </v-flex>
          <v-flex xs6 sm4 md4>
            <doughnutchart
          v-if="billableAccountsLoaded"
          :chartdata="connectionSpeedChart"
          :options="connectionSpeedOptions"
        ></doughnutchart>
          </v-flex>

          
          </v-layout>
          
          
          <v-data-table :items="vlanConnections" :headers="connectionHeaders" :rows-per-page-items="[10]" style="cursor:pointer">
            <template v-slot:items="props">
              <td class="text-xs-center" @click="openVlanSummaryModal(props.item)">
                {{props.item.vlan}}
              </td>
              <td class="text-xs-center" @click="openVlanSummaryModal(props.item)">
                {{props.item.connections}}
              </td>
            </template>
          </v-data-table>
          <!-- <v-card color="white" v-for="vlan in vlanConnections" :key="vlan.vlan">
            <v-card-text>
              <span>VLAN: {{vlan.vlan}}</span>
              <span>Connections: {{vlan.connections}}</span>
            </v-card-text>
          </v-card> -->
        </div>
      <div v-if="displayContents('unlistedConnections')">
        <v-toolbar flat color="white"><v-spacer></v-spacer><v-text-field label="Search" v-model="unlistedSearch"></v-text-field></v-toolbar>
        <v-data-table style="cursor: pointer" :search="unlistedSearch" :items="unlistedAccounts" :headers="headers" >
           <template v-slot:items="props">
              <td class="text-xs-center" v-if="props.item.device" @click="redirectToDevice(props.item.deviceId)">
                 {{props.item.device.deviceMakeModel.name}}
             </td>
             <td v-else @click="redirectToDevice(props.item.deviceId)"></td>

             <td class="text-xs-center" v-if="props.item.device" @click="redirectToDevice(props.item.deviceId)">
                 {{props.item.device.ponMac}}
             </td>
             <td v-else @click="redirectToDevice(props.item.deviceId)"></td>
             
             <td class="text-xs-center" @click="redirectToDevice(props.item.deviceId)" >
                 <span v-if="props.item.access_type">{{props.item.access_type}}</span>
                 <span v-else-if="props.item.tpType">{{tpTypeArray[props.item.tpType-1].name}}</span>
                 </td>
                 <td class="text-xs-center" @click="redirectToDevice(props.item.deviceId)">{{props.item.vlanXlate}}</td>
             <td class="text-xs-center" @click="redirectToDevice(props.item.deviceId)">{{props.item.slanXlate}}</td>
             <td class="text-xs-center" @click="redirectToDevice(props.item.deviceId)">{{props.item.vlan}}</td>
             <td class="text-xs-center" @click="redirectToDevice(props.item.deviceId)">{{props.item.slanXlate}}</td>

         </template>
        </v-data-table>

      </div>
      <div v-if="displayContents('table')">

      
        <v-toolbar flat color="white">
          <v-flex xs3 mx-1><h3 class="grey--text" > Count: <span class="font-weight-light">{{totalItems}}</span></h3></v-flex>
          <!-- <v-flex xs3 mx-1 ><h3 class="grey--text" > Billable Accounts: <span class="font-weight-light" :key="billableCount">{{billableCount}}</span></h3></v-flex> -->
          
            <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="$router.push({name: $route.name, query:{offset: $route.query.bridgeOffset, records: $route.query.bridgeRecords, search: search}})"
      ></v-text-field>
        </v-toolbar>
        <v-data-table
        :items="deviceBridges"
        :headers="headers"
        :loading="isLoading"
        :rows-per-page-items="[15]"
        disable-initial-sort
      item-key="id"
      align-center
      style="cursor: pointer"
      hide-actions
        >
         <template v-slot:items="props">
             <td class="text-xs-center" v-if="props.item.device&&props.item.device.deviceMakeModel" @click="redirectToDevice(props.item.deviceId)">
                 {{props.item.device.deviceMakeModel.name}}
             </td>
             <td v-else @click="redirectToDevice(props.item.deviceId)"></td>

             <td class="text-xs-center" v-if="props.item.device" @click="redirectToDevice(props.item.deviceId)">
                 {{props.item.device.ponMac}}
             </td>
             <td v-else @click="redirectToDevice(props.item.deviceId)"></td>
             
             <td class="text-xs-center"  @click="redirectToDevice(props.item.deviceId)">
                 <span v-if="props.item.access_type">{{props.item.access_type}}</span>
                 <span v-else-if="props.item.tpType">{{tpTypeArray[props.item.tpType-1].name}}</span>
                 </td>
                 <td class="text-xs-center" @click="redirectToDevice(props.item.deviceId)">{{props.item.vlanXlate}}</td>
             <td class="text-xs-center" @click="redirectToDevice(props.item.deviceId)">{{props.item.slanXlate}}</td>
             <td class="text-xs-center" @click="redirectToDevice(props.item.deviceId)">{{props.item.vlan}}</td>
             <td class="text-xs-center" @click="redirectToDevice(props.item.deviceId)">{{props.item.slanXlate}}</td>


         </template>
        </v-data-table>
         <div class="text-xs-center pt-2 white" :key="$route.query.bridgeOffset||totalItems">
      <v-layout wrap>
        <v-flex xs12>
          <v-pagination
            v-model="page"
            :length="totalItems>0?Math.ceil(totalItems/15):0"
            :total-visible="7"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </div>
    </div>

    <v-dialog v-model="vlanSummaryModal" persistent width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">VLAN: {{selectedVlan.vlan}} </h3>
          <h3 class="title white--text px-2">Count: {{selectedVlan.connections}}</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="vlanSummaryModal=false, vlanSummaryData=[], selectedVlan={}">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="vlanSearch"></v-text-field>
          </v-toolbar>
          <v-data-table
        :items="vlanSummaryData"
        :headers="vlanConnectionHeaders"
        :rows-per-page-items="[15]"
        :search="vlanSearch"
        disable-initial-sort
      item-key="id"
      align-center
      style="cursor: pointer"
      hide-actions
        >
         <template v-slot:items="props">
             <td class="text-xs-center" v-if="props.item.device" @click="redirectToDevice(props.item.deviceId)">
                 {{props.item.device.ponMac}}
             </td>
             <td v-else></td>
             <td class="text-xs-center">{{props.item.downstreamRate}}</td>
             <td class="text-xs-center">{{props.item.upstreamRate}}</td>

         </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import Api from '../services/Api'
import BarChart from "./BarChart.vue";
import PieChart from "./PieChart.vue";
import LineChart from "./LineChart.vue";
import DoughnutChart from "./DoughnutChart.vue";

export default {
  components: {
    barchart: BarChart,
    piechart: PieChart,
    linechart: LineChart,
    doughnutchart: DoughnutChart
  },
    data(){
        return {
          activeTabName: '',
          unlistedSearch: '',
          connectionSpeeds: [],
          connectionSpeedChart: {},
          connectionSpeedOptions: {},
            deviceBridges: [],
            vlanConnections: [],
            vlanConnectionChart: {},
            vlanConnectionChartOptions: {},
            billableVlanConnectionChart: {},
            billableVlanConnectionChartOptions: {},
            loaded: false,
            unlistedAccounts: [],
            organisationBridgeTemplates: [],
            page: 1,
            pagination: {
                totalItems: 0,
                rowsPerPage: this.$route.query.bridgeRecords
            },
            totalItems: 0,
            billableCount: 0,
            billableAccounts: [],
            billableAccountsLoaded:false,
            isLoading: true,
            search: '',
            selectedVlan: {},
            vlanSummaryModal: false,
            vlanSummaryData: [],
            vlanSearch: '',
            rgModeArray:[
            {id: 1, name: 'Routed'},
            {id: 2, name: 'BRouted'},
            {id: 3, name: 'rPPPoE'},
            {id: 4, name: 'bPPPoE'},
            {id: 5, name: 'Bridged'},
            {id: 6, name: 'Not Applicable'}

        ],
        tabs: [
        { name: 'dashboard', displayName: 'Metrics'},
        { name: "table", displayName: "Active" },
        // { name: "unlistedConnections", displayName: "Unlisted" },
        // {name: 'Audit', displayName: 'Audit'}

        ],
        tpTypeArray: [
            {id: 1, name: 'Ethernet UNI'},
            {id: 2, name: 'VCC Termination Point'},
            {id: 3, name: 'Mapper Service Profile'},
            {id: 4, name: 'IP Host Config Data'},
            {id: 5, name: 'GEM Interworking Termination Point'},
            {id: 6, name: 'Multicast GEM Interworking Termination Point'},
            {id: 7, name: 'xDSL UNI'},
            {id: 8, name: 'VDSL UNI'},
            {id: 9, name: 'Ether Flow Termination Point'},
            {id: 10, name: 'Physical Path UNI'},
            {id: 11, name: 'Physical Path RF Video UNI'},
            {id: 12, name: 'Physical Path IPTV UNI'},
            {id: 13, name: 'H248 Voice'},
            {id: 14, name: 'SIP Voice'},
            {id: 15, name: 'SIP PLAR Voice'},
            {id: 16, name: 'PWE Termination'},
            {id: 17, name: 'Virtual Ethernet'},
            {id: 18, name: 'dot11 Termination Point'},
            {id: 19, name: 'Fiber LAN Termination Point'},
            {id: 20, name: 'TR69 Termination Point'},
            {id: 21, name: 'Management Termination Point'},
            {id: 22, name: 'MGCP Voice Termination Point'}
        ],
        connectionHeaders: [
           {
          text: "VLAN",
          align: "center",
          value: 'vlan'
        },
                {
          text: "Connections",
          align: "center",
          value: 'connections'
        },
        ],
        vlanConnectionHeaders: [
          {
          text: "Device",
          align: "center",
          value: 'device.ponMac'
        },
                {
          text: "Download Mbps",
          align: "center",
          value: 'downstreamRate'
        },
                {
          text: "Upload Mbps",
          align: "center",
          value: 'upstreamRate'
        }
        ],
            headers: [               
        {
          text: "Model",
          align: "center",
          value: 'device.deviceMakeModel.name'
        },
        {
          text: "Pon Mac",
          align: "center",
          value: 'device.ponMac'
        },
        {
          text: "Connection Type",
          align: "center",
          value: "access_type"
        },
        {
          text: "Inner VLAN",
          align: "center",
          value: "vlanXlate",
        },
        {
          text: "Outer VLAN",
          align: "center",
          value: "slanXlate",
        },
        {
          text: "Uni VLAN",
          align: "center",
          value: "vlan",
        },
        {
          text: "Uni SLAN",
          align: "center",
          value: "slan",
        },
      ],
        }
    },
    watch: {
        '$route.query.bridgeOffset': {
       immediate: true,
      handler(value){
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.search&&this.$route.query.search!=""){      
        
        Api()
        .get('/deviceBridge',{
          params: {
          search: this.$route.query.search,
          offset: this.$route.query.bridgeOffset,
          records: this.$route.query.bridgeRecords,
         }
          })
        .then(response=>{
          this.deviceBridges=response.data.result
          this.totalItems = response.data.count
            this.isLoading=false})
      } else if(value != null){
         Api()
        .get('/deviceBridge',{
          params: {
          offset: this.$route.query.bridgeOffset,
          records: this.$route.query.bridgeRecords,
         }
          })
        .then(response=>{
            this.totalItems = response.data.count
          this.deviceBridges=response.data.result
            this.isLoading=false})
      }
    }},
    '$route.query.search': {
       immediate: true,
      handler(value){
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.search&&this.$route.query.search!=""){      
        
        Api()
        .get('/deviceBridge',{
          params: {
          search: this.$route.query.search,
          offset: this.$route.query.bridgeOffset,
          records: this.$route.query.bridgeRecords,
         }
          })
        .then(response=>{
          this.deviceBridges=response.data.result
          this.totalItems = response.data.count
            this.isLoading=false})
      } else if(value != null){
         Api()
        .get('/deviceBridge',{
          params: {
          offset: this.$route.query.bridgeOffset,
          records: this.$route.query.bridgeRecords,
         }
          })
        .then(response=>{
            this.totalItems = response.data.count
          this.deviceBridges=response.data.result
            this.isLoading=false})
      }
    }},
 page(value) {
      if (value && value != "" && value != this.$route.query.bridgeRecords) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.bridgeRecords,
              records: this.$route.query.bridgeRecords,
              search: this.$route.query.search
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.bridgeRecords,
              records: this.$route.query.bridgeRecords
            }
          });
        }
      }
    }
    },
    created(){
      this.setActiveTabName('dashboard')
        this.initialize()
    },
    methods: {
        async initialize(){
          
           await this.$router.push({
      name: this.$route.name,
      query: {
        offset: "0",
        records: "15"
      }
    });
            // this.fetchDeviceBridges()
            await  this.fetchOrganisationBridgeTemplates()
            // this.fetchAudit()
            
            
           
        },
        async fetchAudit(){
          await Api().get('/devices/audit').then(res=>{
            console.log(res.data)
          })
        },
        async fetchOrganisationBridgeTemplates(){
          await Api().get('/organisationBridgeTemplate').then(response=>{
            this.organisationBridgeTemplates = response.data
            let billable = this.organisationBridgeTemplates.filter(x=> x.isBillable)
            let innerVlans = billable.map(x=>x.innerVlan)
            let outerVlans = billable.map(x=>x.outerVlan)
            let uniVlan = billable.map(x=>x.uniVlan)
            let uniSlan = billable.map(x=>x.uniSlan)
            let array = [...new Set([...innerVlans, ...outerVlans, ...uniVlan, ...uniSlan])];
            let index = array.indexOf(0)
            let indexNull = array.indexOf(null)

            if(index!=-1){
              array.splice(index, 1)
            }
            if(indexNull!=-1){
              array.splice(indexNull, 1)
            }
            this.fetchBillableCount(array)
            this.fetchBillable(array)
            this.fetchVlanConnections()
          })
        },
        fetchUnlistedBridges(data){
          Api().post('/deviceBridges/unlisted', data).then(response=>{
            this.unlistedAccounts = response.data
          })
        },
        fetchBillableCount(data){
          Api().post('/deviceBridges/billable/count', data).then(res=>{
            this.billableCount = res.data.count
          })
        },
        fetchBillable(array){
          Api().post('/deviceBridge/all/billable').then(res=>{
            let result=[]
            let vlans = array
            // let vlans = [...new Set(res.data.map(x=>x.vlanXlate))].sort((a,b) => (a > b) ? 1 : ((b > a) ? -1 : 0)); 
            for(let i=0;i<vlans.length;i++){
              let filter = res.data.filter(x=>x.vlanXlate == vlans[i])
              result.push({vlan: vlans[i], count: filter.length, data: filter, speeds: []})
            }
            
            for(let i=0;i<result.length;i++){
              let speeds = [...new Set(result[i].data.map(x=>x.downstreamRate))]
              for(let j=0; j<speeds.length;j++){
                let speedFilter = result[i].data.filter(x=>x.downstreamRate == speeds[j]).length
                result[i].speeds.push({downloadMbps: speeds[j], count: speedFilter})
              }
            }
            let allSpeeds = [...new Set(res.data.map(x=>x.downstreamRate))]
            let speedSummary = []
            for(let i=0; i<allSpeeds.length;i++){
              let filter = res.data.filter(x=>x.downstreamRate === allSpeeds[i])
              speedSummary.push({downloadMbps: allSpeeds[i], count: filter.length})
            }
            this.billableAccounts = result
            speedSummary = speedSummary.filter(x=>x.downloadMbps != null)
            this.connectionSpeeds = speedSummary.sort((a,b) => (a.downloadMbps > b.downloadMbps) ? 1 : ((b.downloadMbps > a.downloadMbps) ? -1 : 0)); 
            this.loadBillableChartData()
            

          })
        },
        async fetchVlanConnections(){
          await Api().get('/deviceBridges/metrics').then(response=>{
            this.vlanConnections = response.data.sort((a,b) => (a.vlan > b.vlan) ? 1 : ((b.vlan > a.vlan) ? -1 : 0)); 
            this.loadChartData()
            
          })
        },
        redirectToDevice(id){
      this.$router.push({
        path: "/devices/" + id,
      });
    },
    async fetchConnectionsByVlan(vlan){
      let result = []
      await Api().get('/deviceBridges/byVlan/'+vlan).then(res=>{
        result = res.data
      })
      return result
    },
    async openVlanSummaryModal(item){
      this.selectedVlan = item
      this.vlanSearch = ''
      this.vlanSummaryData = await this.fetchConnectionsByVlan(this.selectedVlan.vlan)
      this.vlanSummaryModal = true
    },
        displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) { 
      this.activeTabName = name;
    },
    getRandomColors(number) {
      var letters = "0123456789ABCDEF";
      var color = "#";
      let array = { background: [], border: [] };
      for (let x = 0; x < number; x++) {
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        array.border.push(color);
        array.background.push(this.pSBC(0.35, color));
        color = "#";
      }
      return array;
    },
    pSBC(p, c0, c1, l) {
      let r,
        g,
        b,
        P,
        f,
        t,
        h,
        i = parseInt,
        m = Math.round,
        a = typeof c1 == "string";
      if (
        typeof p != "number" ||
        p < -1 ||
        p > 1 ||
        typeof c0 != "string" ||
        (c0[0] != "r" && c0[0] != "#") ||
        (c1 && !a)
      )
        return null;
      if (!this.pSBCr)
        this.pSBCr = d => {
          let n = d.length,
            x = {};
          if (n > 9) {
            ([r, g, b, a] = d = d.split(",")), (n = d.length);
            if (n < 3 || n > 4) return null;
            (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
              (x.g = i(g)),
              (x.b = i(b)),
              (x.a = a ? parseFloat(a) : -1);
          } else {
            if (n == 8 || n == 6 || n < 4) return null;
            if (n < 6)
              d =
                "#" +
                d[1] +
                d[1] +
                d[2] +
                d[2] +
                d[3] +
                d[3] +
                (n > 4 ? d[4] + d[4] : "");
            d = i(d.slice(1), 16);
            if (n == 9 || n == 5)
              (x.r = (d >> 24) & 255),
                (x.g = (d >> 16) & 255),
                (x.b = (d >> 8) & 255),
                (x.a = m((d & 255) / 0.255) / 1000);
            else
              (x.r = d >> 16),
                (x.g = (d >> 8) & 255),
                (x.b = d & 255),
                (x.a = -1);
          }
          return x;
        };
      (h = c0.length > 9),
        (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
        (f = this.pSBCr(c0)),
        (P = p < 0),
        (t =
          c1 && c1 != "c"
            ? this.pSBCr(c1)
            : P
            ? { r: 0, g: 0, b: 0, a: -1 }
            : { r: 255, g: 255, b: 255, a: -1 }),
        (p = P ? p * -1 : p),
        (P = 1 - p);
      if (!f || !t) return null;
      if (l)
        (r = m(P * f.r + p * t.r)),
          (g = m(P * f.g + p * t.g)),
          (b = m(P * f.b + p * t.b));
      else
        (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
          (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
          (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
      (a = f.a),
        (t = t.a),
        (f = a >= 0 || t >= 0),
        (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
      if (h)
        return (
          "rgb" +
          (f ? "a(" : "(") +
          r +
          "," +
          g +
          "," +
          b +
          (f ? "," + m(a * 1000) / 1000 : "") +
          ")"
        );
      else
        return (
          "#" +
          (
            4294967296 +
            r * 16777216 +
            g * 65536 +
            b * 256 +
            (f ? m(a * 255) : 0)
          )
            .toString(16)
            .slice(1, f ? undefined : -2)
        );
    },
    async loadChartData(){
      let colors = this.getRandomColors(this.vlanConnections.length);
      (this.vlanConnectionChart = {
        labels: this.vlanConnections.map(x => x.vlan),
        datasets: [
          {
            label: "Vlan",
            data: this.vlanConnections.map(x => x.connections),
            backgroundColor: colors.background,
            borderColor: colors.border,
            borderWidth: 1
          }
        ]
      }),
        (this.vlanConnectionChartOptions = {
          title: {
            display: true,
            text: "Connections by VLAN"
          }});

     

    this.loaded = true
    
    },

    async loadBillableChartData(){
       (this.billableVlanConnectionChart = {
        labels: this.billableAccounts.map(x => x.vlan),
        datasets: [
          {
            label: "Vlan",
            data: this.billableAccounts.map(x => x.count),
            backgroundColor: this.pSBC(0.35, "#72cae8") ,
            borderColor: "#72cae8",
            borderWidth: 1
          }
        ],
      }),
        (this.billableVlanConnectionChartOptions = {
          title: {
            display: true,
            text: "Billable Connections"
          }});
      
      let connectionColors = this.getRandomColors(this.connectionSpeeds.length);
      (this.connectionSpeedChart = {
        labels: this.connectionSpeeds.map(x => x.downloadMbps),
        datasets: [
          {
            label: "Mbps",
            data: this.connectionSpeeds.map(x => x.count),
            backgroundColor: connectionColors.background,
            borderColor: connectionColors.border,
            borderWidth: 1
          }
        ],
      }),
        (this.connectionSpeedOptions = {
          title: {
            display: true,
            text: "Speed (Mbps)"
          }});

      this.billableAccountsLoaded=true
    }

    
    }
    
}
</script>